import { CATEGORY_NECESSARY } from '../config/constants';
import addSelectedCategoriesConsent from './addSelectedCategoriesConsent';

const addNecessaryCategoriesConsent = () => {
    addSelectedCategoriesConsent([CATEGORY_NECESSARY]);
};

export default addNecessaryCategoriesConsent;
